// extracted by mini-css-extract-plugin
export default {"itemInside":"fouFNtevKiv","itemProfileInside":"fouWClu27dl","itemContent":"fouyJuJY0yR","noPointerHeading":"fouDsDApEVD","heading":"fouOzFMWt8T","item":"foubR_DbdGB"};